import { Injectable } from "@angular/core";

import { SessionStorage } from "@dffedb/util";

@Injectable({ providedIn: "root" })
export class SilentLoginService {
    private readonly key = "logget-paa-via-silent-login";

    constructor(public readonly sessionStorage: SessionStorage) {}

    public get erLoggetPaaViaSilentLogin(): boolean {
        return this.sessionStorage.getItem(this.key) === "true";
    }

    public set erLoggetPaaViaSilentLogin(value: boolean) {
        this.sessionStorage.setItem(this.key, value ? "true" : "false");
    }
}
